import { ActionType, createAsyncAction } from "typesafe-actions";

import SortOrder from "@mapmycustomers/shared/enum/SortOrder";
import {
  EntitiesSupportingHistory,
  EntityTypeSupportingHistory,
} from "@mapmycustomers/shared/types/entity";
import { EntityHistoryRowWithRecord } from "@mapmycustomers/shared/types/entity/EntityHistoryRow";
import { FilterModel } from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";

export const fetchHistory = createAsyncAction(
  "@component/entityHistory/fetchHistory/request",
  "@component/entityHistory/fetchHistory/success",
  "@component/entityHistory/fetchHistory/failure"
)<
  {
    entityId: EntitiesSupportingHistory["id"];
    entityType: EntityTypeSupportingHistory;
    filter: FilterModel;
    page: number;
    sortFieldName: string;
    sortOrder: SortOrder;
  },
  { history: EntityHistoryRowWithRecord[]; pageCount: number },
  void
>();

export type Actions = ActionType<typeof fetchHistory>;
